// Angular
import { Component, Inject } from '@angular/core';
// Material
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'wait-dialog',
    templateUrl: './wait-dialog.component.html',
})
export class WaitDialogComponent {
    // prettier-ignore
    constructor(
        public dialogRef: MatDialogRef<WaitDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    /***************/
    /*  LIFECYCLE  */
    /***************/

    /*************/
    /*  ACTIONS  */
    /*************/

    /*************************/
    /*  COMPONENT FUNCTIONS  */
    /*************************/
}
